import LanguageStore from './flux/LanguageStore';
import React from 'react';
/**
 * Helper class to localize strings
 */
class Translator {
  /**
   * Maps the given text to its translation in the given language.
   *
   * @param text
   * @param language
   * @returns {*}
   */
  static translate(text, language = LanguageStore.getState()) {
    return LANGUAGE_MAP[language] && LANGUAGE_MAP[language][text]
      ? LANGUAGE_MAP[language][text]
      : text.replace(new RegExp('_', 'g'), ' ');
  }
}

const LANGUAGE_MAP = {
  en: {
    "Click on the leather part you want to customize on the 3D model." : "Click on the leather panel you want to customize on the 3D model.",
    "Please select your design": "Please select your color option",
    "Existing design": "Existing color",
    "Custom design": "Custom color",
    "Select your design": "Select your color option",
    "Select Custom design to change leather colors, select the accessories you want and apply your own text and images" : "Select Custom color to change leather colors, select the accessories you want and apply your own text and images",
    "custom design": "custom color",
    "back_1": "One patch",
    "back_2": "Two patch",
    "back_3": "Three patch",
    "Product": "Product",
    "M": "Man",
    "F": "Lady",
    "Taking screenshots…": "Wait a little bit more…",
    "COMMERCIAL_TRANSFER": "TRANSFER",
    "COMMERCIAL_LEATHER_PATCH": "LEATHER PATCH",
    "COMMERCIAL_DIRECT_PRINT": "DIRECT PRINT",
    "COMMERCIAL_STANDARD": "STANDARD",
    "COMMERCIAL_COLORED": "CUSTOM",
    "COMMERCIAL_LIMITED": "LIMITED",
    "Chest" : "Front",
    "chest_1" : "front 1",
    "chest_2" : "front 2",
    "chest_3" : "front 3",
    "chest_6" : "front 6",
    "chest_8" : "front 8",
    "No products available." : "Coming soon.",
    "Available in short and tall sizes": "Available in short and tall sizes",
    "S/T Sizes": "S/T Sizes",
    "Choose your size type" : "Choose your size type",
    " - Not available for this model" : " - Not available for the selected model",
    "BackButton" : "Back",
    "Go to store" : "Shop Online",
    "Buy online available" : "Buy online available",
    "* By signing this form, you agree that you have read and understood the Dainese S.p.A. Privacy Policy, available at Privacy Policy Dainese, and agree to permit Dainese S.p.A. to collect and use the personal data accordingly.":<span>* By signing this form, you agree that you have read and understood the Dainese S.p.A. Privacy Policy, available at <a target="_blank" style={{color:'#fff', textDecoration:'underline'}} href="https://policy.dainese.com/privacy">Privacy Policy Dainese</a>, and agree to permit Dainese S.p.A. to collect and use the personal data accordingly.</span>,
    "Please allow 72 hours for the store to contact you, if you have not heard anything after that please contact us directly HERE so we can assist you." :<span>Please allow 72 hours for the store to contact you, if you have not heard anything after that please contact us directly <a className="thankyou__mailto" target="_blank" href="https://www.dainese.com/gb/en/dainese/contact-us/contact-dainese.html">HERE</a> so we can assist you.</span>,
    "Special colors" : "SPECIAL COLORS",
    "Standard colors" : "STANDARD COLORS",
    "Fluorescent colors" : "FLUORESCENT COLORS",
    "Fill-in the form below and select if you would like to purchase from one of our Retail Stores, Certified Centers, Design Centers or directly from Dainese (only available for Custom Colour).": "Fill-in the form below and select if you would like to purchase from one of our Retail Stores, Certified Centers, Design Centers (only available for standard sizes) or directly from Dainese (only available for Custom Colour).",
  },
  it: {
      "M": "Uomo",
      "F": "Donna",
      "COMMERCIAL_TRANSFER": "TRANSFER",
      "COMMERCIAL_LEATHER_PATCH": "TOPPA DI PELLE",
      "COMMERCIAL_DIRECT_PRINT": "STAMPA DIRETTA",
      "COMMERCIAL_STANDARD": "STANDARD",
      "COMMERCIAL_COLORED": "CUSTOM",
      "COMMERCIAL_LIMITED": "LIMITED",
      "Next": "Avanti",
      "...": "...",
      "Your unique customization code:": "Il tuo codice di personalizzazione univoco:",
      "Disclaimer": "Disclaimer",
      "Privacy policy": "Privacy policy",
      "English": "Inglese",
      "Italian": "Italiano",
      "Image": "Immagine",
      "Text": "Testo",
      "Browse…": "Scegli…",
      "Only PNG and JPG file under 2MB allowed.": "Sono ammessi solo PNG e JPG sotto i 2MB",
      "Need suggestions?": "Bisogno di aiuto?",
      "Are you sure you want to change preset?": "Sicuro di voler cambiare le impostazioni?",
      "All the changes you've done will be lost": "Tutte le modifiche andranno perse",
      "Perforated version": "Versione perforata",
      "Standard version": "Versione standard",
      "Custom design": "Colore personalizzato",
      "Standard color": "Colore Standard",
      "Custom fit": "Misura custom",
      "Standard fit": "Misura standard",
      "perforated version": "Versione perforata",
      "standard version": "Versione standard",
      "custom design": "colore personalizzato",
      "standard color": "Colore Standard",
      "custom fit": "Misura custom",
      "Custom color" : "Colore custom",
      "standard fit": "Misura standard",
      "type the text here": "scrivi qui il testo",
      "STROKE": "TRATTO",
      "Yes": "Sì",
      "SMALL": "PICCOLO",
      "MEDIUM": "MEDIO",
      "BIG": "GRANDE",
      "Set": "Imposta",
      "Request an appointment": "Richiedi un appuntamento",
      "Fill-in the form below and request an appointment at one of our Certified Custom Works Centers.": "Compila la seguente form e richiedi un appuntamento in uno dei nostri Centri Custom Works Certificati",
      "You will be able to finalize your purchase with the help of our associates.": "Sarai in grado di finalizzare l'acquisto con l'aiuto di uno dei nostri Partner",
      "Sending the request to Dainese…": "Invio richiesta a Dainese",
      "name*": "nome*",
      "surname*": "cognome*",
      "email*": "email*",
      "Choose the store…": "Scegli lo Store…",
      "Loading…": "Caricamento…",
      "phone*": "telefono*",
      "Check our store locator to find the closest Certified Custom Works Center!": "Cerca nel nostro store locator il Centro Custom Works Certificato più vicino!",
      "Required": "Richiesto",
    "* By signing this form, you agree that you have read and understood the Dainese S.p.A. Privacy Policy, available at Privacy Policy Dainese, and agree to permit Dainese S.p.A. to collect and use the personal data accordingly.": <span>* Compilando questa form dichiari che hai letto e compreso la Privacy Policy di Dainese S.p.A, disponibile a <a target="_blank" style={{color:'#fff', textDecoration:'underline'}} href="https://policy.dainese.com/privacy">Privacy Policy Dainese</a> e permetti a Dainese S.p.A. di collezionare ed utilizzare i tuoi dati personali come descritto</span>,
      "I agree to receive special offers, membership benefits, newsletter and brand communications via email and understand I can unsubscribe any time": "Do il consenso a ricevere offerte speciali, vantaggi da socio, newsletter e comunicazioni via email e che posso disiscrivermi in qualunque momento",
      "I consent to provide usage and personal data for a better processing of my interests": "Do il consenso a fornire i dati di utilizzo e personali per una migliore personalizzazione",
      "Request": "Richesta",
      "Loading 3D viewer…": "In caricamento…",
      "Taking screenshots…": "Attendi ancora un attimo…",
      "Saving customization…": "Salvataggio personalizzazione…",
      "Updating customization…": "Aggiornamento personalizzazione…",
      "Save customization": "Salva personalizzazione",
      "Leathers": "Pelli",
      "Click on the leather part you want to customize on the 3D model.": "Clicca sulle parti di pelle che vuoi personalizzare.",
      "Accessories": "Accessori",
      "Click on the accessory you want to customize on the 3D model.": "Clicca sull'accessorio che vuoi personalizzare.",
      "Patches": "Toppe",
      "Select the patch to customize…": "Seleziona la toppa da personalizzare…",
      "Select the patch configuration…": "Seleziona la configurazione della toppa…",
      "Update": "Aggiorna",
      "New": "Nuovo",
      "Do you want to update the customization or create a new one?": "Vuoi aggiornare la personalizzazione oppure crearne una nuova?",
      "Update the customization or create a new one.": "Aggiorna la personalizzazione o creane una nuova.",
      "Configurator": "Configuratore",
      "Well done!": "Ben fatto!",
      "The customization is completed and your product ready to be crafted.": "La personalizzazione è completa e il tuo prodotto è pronto per essere creato.",
      "Please copy and keep the unique code assigned:": "Copia e salva il codice univoco assegnato:",
      "Product Right": "Lato destro",
      "Product front": "Fronte",
      "Product Back": "Retro",
      "Product Left": "Lato sinistro",
      "Proceed": "Procedi",
      "Please provide a configuration code.": "Inserisci il codice di configurazione.",
      "Configuration not found.": "Configurazione non trovata.",
      "Looking for customization…": "Ricerca della configurazione…",
      "Loading customization…": "Caricamento della configurazione…",
      "Select your country to begin...": "Seleziona il tuo paese…",
      "Loading countries...": "Caricamento dei paesi…",
      "Start the experience": "Inizia",
      "Retrieve previous configuration": "Recupera la configurazione precedente",
      "Enter": "Invio",
      "Insert the code to retrieve your previous configuration": "Inserisci il codice per recuperare la tua configruazione precedente",
      "Choose your color": "Seleziona il colore",
      "Choose a standard color option or go through our 3D product and customize colors accessories and add-on following your own creativity.": "Seleziona un colore standard oppure tramite il nostro configuratore 3D perzonalizza i colori gli accessori e le aggiunte secondo la tua creatività.",
      "Select your design": "Scegli il colore",
      "Select Custom design to change leather colors, select the accessories you want and apply your own text and images" : "Seleziona \"Colore personalizzato\" per cambiare i colori delle pelli, seleziona gli accessori che vuoi e applica i tuoi testi e immagini",
      "Please select your design": "Seleziona la variante colore",
      "Existing design": "Colori standard",
      "Customize your garment": "Personalizza il tuo abbigliamento",
      "Choose color": "Seleziona il colore",
      "SELECT": "SELEZIONA",
      "Choose your fit": "Seleziona la tua misura",
      "Choose a standard size or make your garment adjusted to your own body proportions.": "Seleziona una misura standard o richiedi il tuo abbigliamento fatto su misura",
      "Would you like to customize your fit?": "Vuoi personalizzare la taglia?",
      "No": "No",
      "Choose your size": "Seleziona la tua taglia",
      "Shop on line": "Acquista on-line",
      "Pick a perforated leather for maximum ventilation or standard for mild ventilation": "Scegli una pelle perforata per massima traspirazione o standard per lieve traspirazione",
      "Select leather perforation": "Seleziona la perforatura della pelle",
      "NEXT": "AVANTI",
      "Pick your model": "Seleziona il tuo modello",
      "These are the models available, choose the one you prefer.": "Questi sono i modelli disponibili, scegli quello che preferisci.",
      "Loading products…": "Caricamento dei prodotti…",
      "No products available.": "Nessun prodotto disponibile.",
      "Select your product": "Seleziona il tuo prodotto",
      "Please select the product to be customized": "Seleziona il prodotto da personalizzare",
      "SUIT": "TUTE",
      "JACKET": "GIACCHE",
      "TROUSERS": "PANTALONI",
      "BOOTS" : "STIVALI",
      "Select": "Seleziona",
      "Standard leather": "Pelle standard",
      "Perforated leather": "Pelle perforata",
      "The 3D model shown is intended for illustration purpose only.": "Il modello 3D è a fini di pura illustrazione.",
      "Actual product may vary from the graphical representation.": "Il prodotto finale potrebbe variare dalla rappresentazione grafica.",
      "Start": "Start",
      "Product ": "Prodotto",
      "Design ": "Design",
      "Fit ": "Misura",
      "KNEE_SLIDER": "Slider ginocchio",
      "ELBOW_SLIDER": "Slider gomito",
      "SHOULDER_PLATE": "Placca spalla",
      "KNEE_PLATE": "Placca ginocchio",
      "ELBOW_PLATE": "Placca gomito",
      "knee_sliders": "Slider ginocchia",
      "elbow_sliders": "Slider gomiti",
      "shoulder_plates": "Placche spalle",
      "knee_plates": "Placche ginocchia",
      "elbow_plates": "Placche gomiti",
      "Knee_sliders": "Slider ginocchia",
      "Elbow_sliders": "Slider gomiti",
      "Shoulder_plates": "Placche spalle",
      "Knee_plates": "Placche ginocchia",
      "Elbow_plates": "Placche gomiti",
      "Chest": "Petto",
      "Upperarm_L": "Braccio superiore sinistro",
      "Upperarm_R": "Braccio superiore destro",
      "Back": "Retro",
      "Collarbone_L": "Clavicola sinistra",
      "Collarbone_R": "Clavicola destra",
      "Forearm_L": "Avambraccio sinistro",
      "Forearm_R": "Avambraccio destro",
      "Shin_L": "Stinco sinistro",
      "Shin_R": "Stinco destro",
      "Front_leg_L": "Gamba Anteriore sinistra",
      "Front_leg_R": "Gamba Anteriore destra",
      "Back_leg_L": "Gamba Post. SX",
      "Back_leg_R": "Gamba Post. DX",
      "Lowerback": "Lombi",
      "Hump": "Gobba",
      "Collarbone": "Clavicola",
      "Forearm": "Avambraccio",
      "Leg": "Gamba",
      "Shin": "Stinco",
      "Shoulder": "Spalla",
      "Back_1": "Retro 1",
      "Back_2": "Retro 2",
      "Back_3": "Retro 3",
      "Chest_1": "Petto 1",
      "Chest_3": "Petto 3",
      "Chest_8": "Petto 8",
      "Hump_1": "Gobba 1",
      "Hump_2": "Gobba 2",
      "Hump_3": "Gobba 3",
      "Upperarm_L_1": "Braccio Superiore SX 1",
      "Upperarm_L_2": "Braccio Superiore SX 2",
      "Upperarm_L_3": "Braccio Superiore SX 3",
      "Upperarm_R_1": "Braccio Superiore DX 1",
      "Upperarm_R_2": "Braccio Superiore DX 2",
      "Upperarm_R_3": "Braccio Superiore DX 3",
      "Collarbone_L_2": "Clavicola SX 2",
      "Collarbone_R_2": "Clavicola DX 2",
      "Chest_2": "Petto 2",
      "Chest_6": "Petto 6",
      "Thigh_L": "Coscia SX",
      "Thigh_R": "Coscia DX",
      "Strap": "Strap",
      "Shoulder_L_1": "Spalla SX 1",
      "Shoulder_L_2": "Spalla SX 2",
      "Shoulder_L_3": "Spalla SX 3",
      "Shoulder_R_1": "Spalla DX 1",
      "Shoulder_R_2": "Spalla DX 2",
      "Shoulder_R_3": "Spalla DX 3",
      "Arm_L": "Braccio sinistro",
      "Arm_R": "Braccio destro",
      "Collarbone_L_1": "Clavicola SX 1",
      "Collarbone_R_1": "Clavicola DX 1",
      "Thigh_back_L": "Retro Coscia SX",
      "Thigh_back_R": "Retro Coscia DX",
      "Thigh_front_L": "Fronte Coscia SX",
      "Thigh_front_R": "Fronte Coscia DX",
      "Leg_L": "Gamba SX",
      "Leg_R": "Gamba DX",
      "Chest_L": "Petto SX",
      "Chest_R": "Petto DX",
      "Shoulder_L": "Spalla SX",
      "Shoulder_R": "Spalla DX",
      "kangaroo": "canguro",
      "cowhide ": "vacchetta",
      "Available in short and tall sizes": "Disponibile in taglie short and tall",
      "S/T Sizes": "Taglie S/T",
      "Choose your size type" : "Seleziona il tipo di taglia",
      " - Not available for this model" : " - Non disponibile per il modello selezionato",
      "Leave your email": "Lascia la tua email",
      "To get your unique customization code": "per ottenere il tuo codice di customizzazione",
      "BackButton" : "Indietro",
      "Go to store" : "Compra online",
      "Buy online available" : "Acquista online",
      "In-store only" : "Solo in negozio",
      "Click here to know more about patches" : "Clicca qui per avere maggiori informazioni sulle toppe",
      "Please note that we will not be able to add the following logos and trade marks: Ducati, Monster, RedBull and VR46. Depending on content and quality of images, our Team will tell you which of the following add-ons will be used:" : "Tieni presente che non sarà possibile aggiungere i seguenti loghi: Ducati, Monster, RedBull and VR46.In base al contenuto e alla qualità delle immagini, il nostro Team ti confermerà quali delle seguenti aggiunte verranno utilizzato:",
      "Offers the highest level of perceived quality and the most durability, but it has design limitations.": "Offre i più alti livelli di qualità e la maggior durata, però ci sono dei limiti nel design.",
      "It's an ink printing onto a faux piece of leather that offers complete design freedom, but has a lower perceived quality level, and reduced durability." : "E' una stampa a inchiostro su un pezzo di pelle che offre completa libertà di design ma ha una qualità percepita inferiore e resistenza ridotta.",
      "Enter your email address to save your garment" : "Inserisci il tuo indirizzo e-mail per salvare il tuo capo personalizzato",
      "You will receive a unique Custom Works code in order to retrieve your design anytime" : "Riceverai un codice di personalizzazione univoco per consultare il tuo design in qualsiasi momento.",
      "Submit" : "Invia",
      "Thank you!": "Grazie!",
      "Please look for an email, checking in junk folder as well, with your unique Custom Works code.": "Cerca la mail con il codice univoco di personalizzazione, controllando anche la cartella Spam.",
      "This allows you to view the design at any time. Please note that any changes will create a new code.": "Questo ti permette di controllare il tuo design in qualsiasi momento. Tieni presente che qualsiasi cambiamento creerà un nuovo codice.",
      "Your unique Custom Works code code is:": "Il tuo codice di personalizzazione univoco è:",
      "Reconfigure": "Riconfigura",
      "Let's get started on your Dainese Custom Works project!" : "Iniziamo il tuo progetto Custom Works!",
      "Fill-in the form below and select if you would like to purchase from one of our Retail Stores, Certified Centers, Design Centers or directly from Dainese (only available for Custom Colour).": "Compila il seguente modulo e seleziona se preferisci acquistare presso un Retail Store, Certified Center, Design Center (solo per taglie standard) o direttamente presso Dainese (disponibile solo per il colore personalizzato)",
      "* I have authorization to use trademarks and images" : "* Ho l'autorizzazione all'utilizzo marchi registrati e immagini",
      "A member of the Dainese Custom Works will be contacting you" : "Un membro del Custom Works Dainese ti contatterà",
      "A message will be sent to the store and you will be contacted": "Verrà inviato un messaggio allo store e sarai poi contattato",
      "Buy in-store" : "Acquisto in negozio",
      "Buy Online" : "Acquista online",
      "for submitting your design" : "per aver inviato il tuo design",
      "A member of our Custom Works Consumer Care team will contact you shortly to confirm your design and talk you through the ordering process." : "Un membro del Team Custom Works Consumer Care ti contatterà a breve per confermarti il design e per spiegarti il procedimento dell'ordine.",
      "We have submitted your design to your preferred store." : "Abbiamo inviato il tuo design allo store che hai scelto.",
      "They will contact you in order to arrange an appointment." : "Ti contatteranno per fissare un appuntamento.",
      "Please use the below reference code:" : "Utilizza questo codice di riferimento:",
      "Please allow 72 hours for the store to contact you, if you have not heard anything after that please contact us directly HERE so we can assist you." :<span>Attendi 72 ore prima che il negozio ti contatti. Se non ricevi alcuna comunicazione, contattaci <a className="thankyou__mailto" target="_blank" href="https://www.dainese.com/it/it/dainese/contact-us/contact-dainese.html">QUI</a> per avere supporto.</span>,
      "Cannot find a store near you? CLICK HERE" : "Non riesci a trovare uno store vicino a te? CLICCA QUA",
      "Special colors" : "COLORI SPECIALI",
      "Standard colors" : "COLORI STANDARD",
      "Fluorescent colors" : "COLORI FLUORESCENTI",
      "There was an error saving your garment. You are being redirected back, check your changes and save again. If repeated please contact the help desk." : "C'è stato un errore durante il salvataggio del prodotto, Stai per essere reindirizzato al configuratore, controlla le tue modifiche e salva nuovamente. Se si ripete, contatta l'assistena clienti."
  },
  fr:{
      "M" : "Homme",
        "F" : "Femme",
        "COMMERCIAL_TRANSFER" : "TRANSFERT",
        "COMMERCIAL_LEATHER_PATCH" : "EMPIÈCEMENT EN CUIR",
        "COMMERCIAL_DIRECT_PRINT" : "IMPRESSION DIRECTE",
        "COMMERCIAL_STANDARD" : "STANDARD",
        "COMMERCIAL_COLORED" : "CUSTOM",
        "COMMERCIAL_LIMITED" : "LIMITÉE",
        "Next" : "Suivant",
        "..." : "...",
        "Your unique customization code:" : "Votre code de personnalisation unique:",
        "Disclaimer" : "Clause de non-responsabilité",
        "Privacy policy" : "Politique de confidentialité",
        "English" : "Anglais",
        "Italian" : "Italien",
        "Image" : "Image",
        "Text" : "Texte",
        "Browse…" : "Parcourir...",
        "Only PNG and JPG file under 2MB allowed." : "Seuls les fichiers PNG et JPG inférieurs à 2 Mo sont autorisés.",
        "Need suggestions?" : "Souhaitez-vous des suggestions ?",
        "Are you sure you want to change preset?" : "Êtes-vous sûr(e) de vouloir modifier les préconfigurations ?",
        "All the changes you've done will be lost" : "Toutes les modifications que vous avez apportées seront perdues",
        "Perforated version" : "Version perforée",
        "Standard version" : "Version standard",
        "Custom design" : "Couleur personnalisé",
        "Standard color" : "Couleur standard",
        "Custom color" : "Couleur personnalisé",
        "Custom fit" : "Taille personnalisée",
        "Standard fit" : "Taille standard",
        "perforated version" : "Version perforée",
        "standard version" : "Version standard",
        "custom design" : "couleur personnalisé",
        "standard color" : "Couleur standard",
        "custom fit" : "Taille personnalisée",
        "standard fit" : "Taille standard",
        "type the text here" : "entrer le texte ici",
        "STROKE" : "TRAIT",
        "Yes" : "Oui",
        "SMALL" : "PETIT",
        "MEDIUM" : "MOYEN",
        "BIG" : "GRAND",
        "Set" : "Appliquer",
        "Request an appointment" : "Demande de rendez-vous",
        "Fill-in the form below and request an appointment at one of our Certified Custom Works Centers." : "Remplissez le formulaire ci-dessous et demandez un rendez-vous à l’un de nos Centres Custom Works certifiés.",
        "You will be able to finalize your purchase with the help of our associates." : "Vous pourrez finaliser votre achat avec l’aide de nos collaborateurs.",
        "Sending the request to Dainese…" : "Envoi de la demande à Dainese…",
        "name*" : "prénom*",
        "surname*" : "nom de famille*",
        "email*" : "e-mail*",
        "Choose the store…" : "Choisir le magasin…",
        "Loading…" : "Chargement en cours…",
        "phone*" : "téléphone*",
        "Check our store locator to find the closest Certified Custom Works Center!" : "Consultez notre store locator pour trouver le Centre Custom Works certifié le plus proche !",
        "Required" : "Obligatoire",
    "* By signing this form, you agree that you have read and understood the Dainese S.p.A. Privacy Policy, available at Privacy Policy Dainese, and agree to permit Dainese S.p.A. to collect and use the personal data accordingly." : <span>* En signant ce formulaire, vous reconnaissez avoir lu et compris la politique de confidentialité de Dainese S.p.A. disponible à la rubrique <a target="_blank" style={{color:'#fff', textDecoration:'underline'}} href="https://policy.dainese.com/privacy">Politique de confidentialité Dainese</a> et vous autorisez Dainese S.p.A. à recueillir et utiliser les données personnelles en conséquence.</span>,
        "I agree to receive special, offers membership benefits, newsletter and brand communications via email and understand I can unsubscribe any time" : "J’accepte de recevoir des offres spéciales, des avantages membres, des newsletters et des communications de la marque via e-mail et je comprends que je peux me désinscrire à tout moment",
        "I consent to provide usage and personal data for a better processing of my interests" : "J’accepte de fournir des données d’usage et personnelles en vue d'améliorer le traitement de mes intérêts",
        "Request" : "Demande",
        "Loading 3D viewer…" : "Chargement en cours…",
        "Taking screenshots…" : "Encore un instant…",
        "Saving customization…" : "Enregistrement de la personnalisation…",
        "Updating customization…" : "Mise à jour de la personnalisation…",
        "Save customization" : "Enregistrer la personnalisation",
        "Leathers" : "Cuirs",
        "Click on the leather part you want to customize on the 3D model." : "Cliquez sur la partie en cuir que vous souhaitez personnaliser sur le modèle 3D.",
        "Accessories" : "Accessoires",
        "Click on the accessory you want to customize on the 3D model." : "Cliquez sur l’accessoire que vous souhaitez personnaliser sur le modèle 3D.",
        "Patches" : "Empiècements",
        "Select the patch to customize…" : "Sélectionnez l’empiècement à personnaliser…",
        "Select the patch configuration…" : "Sélectionnez la configuration de l’empiècement…",
        "Update" : "Actualiser",
        "New" : "Nouveau",
        "Do you want to update the customization or create a new one?" : "Voulez-vous actualiser la personnalisation ou en créer une nouvelle ?",
        "Update the customization or create a new one." : "Actualiser la personnalisation ou en créer une nouvelle.",
        "Configurator" : "Configurateur",
        "Well done!" : "Parfait !",
        "The customization is completed and your product ready to be crafted." : "La personnalisation est terminée et votre produit est prêt à être confectionné.",
        "Please copy and keep the unique code assigned:" : "Veuillez copier et conserver le code unique vous ayant été assigné:",
        "Product Right" : "Côté droit du produit",
        "Product front" : "Produit vu de face",
        "Product Back" : "Produit vu de dos",
        "Product Left" : "Côté gauche du produit",
        "Proceed" : "Poursuivre",
        "Please provide a configuration code." : "Veuillez indiquer un code de configuration.",
        "Configuration not found." : "Configuration non trouvée.",
        "Looking for customization…" : "Recherche de personnalisation…",
        "Loading customization…" : "Chargement de personnalisation en cours…",
        "Select your country to begin..." : "Sélectionnez d’abord votre pays...",
        "Loading countries..." : "Chargement des pays en cours...",
        "Start the experience" : "Commencez l’expérience",
        "Retrieve previous configuration" : "Récupérer la configuration précédente",
        "Enter" : "Entrer",
        "Insert the code to retrieve your previous configuration" : "Saisissez le code pour récupérer votre configuration précédente",
        "Choose your color" : "Choisissez votre couleur",
        "Choose a standard color option or go through our 3D product and customize colors accessories and add-on following your own creativity." : "Choisissez une option de couleur standard ou parcourez nos produits 3D puis personnalisez les couleurs des accessoires et ajouts en laissant libre cours à votre créativité.",
        "Select your design" : "Sélectionnez votre option de couleur",
        "Select Custom design to change leather colors, select the accessories you want and apply your own text and images" : "Sélectionnez \"Couleur personnalisée\" pour changer les couleurs du cuir, sélectionnez les accessoires que vous souhaitez et appliquez votre texte et vos images",
        "Please select your design" : "Veuillez choisir votre couleur",
        "Existing design" : "Couleur existante",
        "Customize your garment" : "Personnalisez votre vêtement",
        "Choose color" : "Choisissez la couleur",
        "SELECT" : "SÉLECTIONNER",
        "Choose your fit" : "Choisissez votre taille",
        "Choose a standard size or make your garment adjusted to your own body proportions." : "Choisissez une taille standard ou confectionnez votre vêtement sur mesure.",
        "Would you like to customize your fit?" : "Souhaitez-vous le personnaliser selon vos mesures ?",
        "No" : "Non",
        "Choose your size" : "Choisissez votre taille",
        "Shop on line" : "Boutique en ligne",
        "Pick a perforated leather for maximum ventilation or standard for mild ventilation" : "Choisissez un cuir perforé pour une ventilation maximale ou un cuir standard pour une  ventilation légère",
        "Select leather perforation" : "Sélectionnez la perforation du cuir",
        "NEXT" : "SUIVANT",
        "Pick your model" : "Choisissez votre modèle",
        "These are the models available, choose the one you prefer." : "Voici les modèles disponibles, choisissez celui que vous préférez.",
        "Loading products…" : "Chargement de produits en ligne…",
        "No products available." : "Aucun produit disponible.",
        "Select your product" : "Sélectionnez votre produit",
        "Please select the product to be customized" : "Veuillez sélectionner le produit à personnaliser",
        "SUIT" : "COMBINAISON",
        "JACKET" : "VESTE",
        "TROUSERS" : "PANTALON",
         "BOOTS" : "BOTTES",
        "Select" : "Sélectionner",
        "Standard leather" : "Cuir standard",
        "Perforated leather" : "Cuir perforé",
        "The 3D model shown is intended for illustration purpose only." : "Le modèle 3D présenté est fourni à des fins d’illustration uniquement.",
        "Actual product may vary from the graphical representation." : "Le produit réel peut être légèrement différent de la représentation graphique.",
        "Start" : "Démarrer",
        "Product" : "Produit",
        "Design" : "Design",
        "Fit" : "Taille",
        "KNEE_SLIDER" : "Slider de genoux",
        "ELBOW_SLIDER" : "Slider de coudes",
        "SHOULDER_PLATE" : "Plaque épaules",
        "KNEE_PLATE" : "Plaque genoux",
        "ELBOW_PLATE" : "Plaque coudes",
        "knee_sliders" : "Sliders de genoux",
        "Knee_sliders" : "Sliders de genoux",
        "elbow_sliders" : "Sliders de coudes",
        "Elbow_sliders" : "Sliders de coudes",
        "shoulder_plates" : "Plaques épaules",
        "Shoulder_plates" : "Plaques épaules",
        "knee_plates" : "Plaques genoux",
        "Knee_plates" : "Plaques genoux",
        "elbow_plates" : "Plaques coudes",
        "Elbow_plates" : "Plaques coudes",
        "Chest" : "Thorax",
        "Upperarm_L" : "Haut du bras gauche",
        "Upperarm_R" : "Haut du bras droit",
        "Back" : "Dos",
        "Collarbone_L" : "Clavicule gauche",
        "Collarbone_R" : "Clavicule droite",
        "Forearm_L" : "Avant-bras gauche",
        "Forearm_R" : "Avant-bras droit",
        "Shin_L" : "Tibia droit",
        "Shin_R" : "Tibia gauche",
        "Front_leg_L" : "Avant jambe gauche",
        "Front_leg_R" : "Avant jambe droite",
        "Back_leg_L" : "Arrière jambe gauche",
        "Back_leg_R" : "Arrière jambe droite",
        "Lowerback" : "Bas du dos",
        "Hump" : "Bosse",
        "Collarbone" : "Clavicule",
        "Forearm" : "Avant-bras",
        "Leg" : "Jambe",
        "Shin" : "Tibia",
        "Shoulder" : "Épaules",
        "chest" : "Thorax",
        "upperarm_L" : "Haut du bras gauche",
        "upperarm_R" : "Haut du bras droit",
        "back" : "Dos",
        "collarbone_L" : "Clavicule gauche",
        "collarbone_R" : "Clavicule droite",
        "forearm_L" : "Avant-bras gauche",
        "forearm_R" : "Avant-bras droit",
        "shin_L" : "Tibia droit",
        "shin_R" : "Tibia gauche",
        "front_leg_L" : "Avant jambe gauche",
        "front_leg_R" : "Avant jambe droite",
        "back_leg_L" : "Arrière jambe gauche",
        "back_leg_R" : "Arrière jambe droite",
        "lowerback" : "Bas du dos",
        "hump" : "Bosse",
        "collarbone" : "Clavicule",
        "forearm" : "Avant-bras",
        "leg" : "Jambe",
        "shin" : "Tibia",
        "shoulder" : "Épaules",
        "Back_1" : "Dos_1",
        "Back_2" : "Dos_2",
        "Back_3" : "Dos_3",
        "Chest_1" : "Thorax_1",
        "Chest_3" : "Thorax_3",
        "Chest_8" : "Thorax_8",
        "Hump_1" : "Bosse_1",
        "Hump_2" : "Bosse_2",
        "Hump_3" : "Bosse_3",
        "Upperarm_L_1" : "Haut du bras gauche_1",
        "Upperarm_L_2" : "Haut du bras gauche_2",
        "Upperarm_L_3" : "Haut du bras gauche_3",
        "Upperarm_R_1" : "Haut du bras droit_1",
        "Upperarm_R_2" : "Haut du bras droit_2",
        "Upperarm_R_3" : "Haut du bras droit_3",
        "Collarbone_L_2" : "Clavicule gauche_2",
        "Collarbone_R_2" : "Clavicule droite_2",
        "Chest_2" : "Thorax_2",
        "Chest_6" : "Thorax_6",
        "Thigh_L" : "Cuisse_G.",
        "Thigh_R" : "Cuisse_D.",
        "Strap" : "Sangle",
        "Shoulder_L_1" : "Épaule gauche_1",
        "Shoulder_L_2" : "Épaule gauche_2",
        "Shoulder_L_3" : "Épaule gauche_3",
        "Shoulder_R_1" : "Épaule droite_1",
        "Shoulder_R_2" : "Épaule droite_2",
        "Shoulder_R_3" : "Épaule droite_3",
        "Arm_L" : "Bras gauche",
        "Arm_R" : "Bras droit",
        "Collarbone_L_1" : "Clavicule gauche_1",
        "Collarbone_R_1" : "Clavicule droite_1",
        "Thigh_back_L" : "Arrière cuisse gauche",
        "Thigh_back_R" : "Arrière cuisse droite",
        "Thigh_front_L" : "Avant cuisse gauche",
        "Thigh_front_R" : "Avant cuisse droite",
        "Leg_L" : "Jambe gauche",
        "Leg_R" : "Jambe droite",
        "Chest_L" : "Thorax côté gauche",
        "Chest_R" : "Thorax côté droit",
        "Shoulder_L" : "Épaule gauche",
        "Shoulder_R" : "Épaule droite",
        "kangaroo" : "kangourou",
        "cowhide" : "cuir de vache",
        "Available in short and tall sizes": "Disponible en tailles short and tall",
        "S/T Sizes": "S/T Tailles",
        "Choose your size type" : "Choisissez votre type de taille",
         " - Not available for this model" : " - Non disponible pour le modèle sélectionné",
        "BackButton" : "retour",
        "Go to store" : "acheter en ligne",
        "Buy online available" : "Achetez en ligne",
        "In-store only" : "En boutique uniquement",
        "Click here to know more about patches" : "En savoir plus sur les patches",
        "Please note that we will not be able to add the following logos and trade marks: Ducati, Monster, RedBull and VR46. Depending on content and quality of images, our Team will tell you which of the following add-ons will be used:" : "Veuillez noter que les logos et les marques suivants ne peuvent pas être ajoutés: Ducati, Monster, RedBull et VR46. En fonction du contenu et de la qualité des images, notre équipe vous indiquera lesquels des patches suivantes seront utilisés.",
        "Offers the highest level of perceived quality and the most durability, but it has design limitations.": "Il offre le plus haut niveau de qualité et la plus grande durabilité, mais il présente des limites en son design.",
        "It's an ink printing onto a faux piece of leather that offers complete design freedom, but has a lower perceived quality level, and reduced durability." : "Il s'agit d'une impression à l'encre sur un faux cuir qui offre une totale liberté de conception, mais le niveau de qualité et la durabilité sont inférieurs.",
        "Enter your email address to save your garment" : "Tapez votre adresse électronique pour sauver votre vêtement",
        "You will receive a unique Custom Works code in order to retrieve your design anytime" : "Vous recevrez un code unique Custom Works afin de pouvoir récupérer votre design à tout moment.",
        "Submit" : "Soumettre",
        "Thank you!": "Merci!",
        "Please look for an email, checking in junk folder as well, with your unique Custom Works code.": "Vous recevrez un email avec votre code unique Custom Works : veuillez vérifier aussi le courrier indésirable.",
        "This allows you to view the design at any time. Please note that any changes will create a new code.": "Cela vous permet d'acceder à votre design à tout moment. Veuillez noter que toute modification créera un nouveau code.",
        "Your unique Custom Works code code is:": "Votre code unique Custom Works est:",
        "Reconfigure": "Reconfigurer",
        "Let's get started on your Dainese Custom Works project!" : "Allez! Commençons votre projet Custom Works Dainese!",
        "Fill-in the form below and select if you would like to purchase from one of our Retail Stores, Certified Centers, Design Centers or directly from Dainese (only available for Custom Colour).": "Remplissez le formulaire ci-dessous et sélectionnez si vous souhaitez acheter dans l'un de nos Dainese Stores, Certified Centers, Design Centers (uniquement disponible pour les tailles standard) ou directement chez Dainese (uniquement disponible pour la couleur personnalisée).",
        "* I have authorization to use trademarks and images" : "* J'ai l'autorisation d'utiliser les marques et les images",
        "A member of the Dainese Custom Works will be contacting you" : "Un membre de l'équipe Dainese Custom Works prendra contact avec vous",
        "A message will be sent to the store and you will be contacted": "Un message sera envoyé au magasin et vous serez contacté",
        "Buy in-store" : "Achetez en boutique",
        "Buy Online" : "Achetez en ligne",
        "for submitting your design" : "pour avoir soumis votre design",
        "A member of our Custom Works Consumer Care team will contact you shortly to confirm your design and talk you through the ordering process." : "Un membre de notre équipe Custom Works Consumer Care vous contactera sous peu pour confirmer votre conception et vous expliquer la démarche.",
        "We have submitted your design to your preferred store." : "Nous avons soumis votre design à votre magasin préféré.",
        "They will contact you in order to arrange an appointment." : "Ils vous contacteront afin de fixer un rendez-vous.",
        "Please use the below reference code:" : "Veuillez utiliser le code de référence ci-dessous:",
        "Please allow 72 hours for the store to contact you, if you have not heard anything after that please contact us directly HERE so we can assist you." :<span>Veuillez patienter 72 heures avant que le magasin vous contacte. Si vous n'avez plus de nouvelles après cela, veuillez nous contacter directement <a className="thankyou__mailto" target="_blank" href="https://www.dainese.com/fr/fr/dainese/contact-us/contact-dainese.html">ICI</a> afin que nous puissions vous aider.</span>,
        "Cannot find a store near you? CLICK HERE" : "Vous ne trouvez pas de magasin près de chez vous? CLIQUEZ ICI",
        "Special colors" : "COULEURS SPECIALES",
        "Standard colors" : "COULEURS STANDARD",
        "Fluorescent colors" : "COULEURS FLUORESCENTES",
        "There was an error saving your garment. You are being redirected back, check your changes and save again. If repeated please contact the help desk." : "Une erreur s'est produite lors de l'enregistrement de votre vêtement. Vous êtes redirigé, vérifiez vos modifications et enregistrez à nouveau. En cas de répétition, veuillez contacter le service d'assistance."

  },
  de:{
    "M" : "Herren",
    "F" : "Damen",
    "COMMERCIAL_TRANSFER" : "TRANSFER",
    "COMMERCIAL_LEATHER_PATCH" : "LEDERPATCH",
    "COMMERCIAL_DIRECT_PRINT" : "DIREKTDRUCK",
    "COMMERCIAL_STANDARD" : "STANDARD",
    "COMMERCIAL_COLORED" : "CUSTOM",
    "COMMERCIAL_LIMITED" : "LIMITIERT",
    "Next" : "Weiter",
    "..." : "...",
    "Your unique customization code:" : "Ihr exklusiver Personalisierungscode:",
    "Disclaimer" : "Disclaimer",
    "Privacy policy" : "Datenschutzrichtlinie",
    "English" : "Englisch",
    "Italian" : "Italienisch",
    "Image" : "Bild",
    "Text" : "Text",
    "Browse…" : "Durchsuchen…",
    "Only PNG and JPG file under 2MB allowed." : "Es sind nur PNG- und JPG-Dateien unter 2 MB zulässig.",
    "Need suggestions?" : "Brauchen Sie Hilfe?",
    "Are you sure you want to change preset?" : "Möchten Sie die Voreinstellungen wirklich ändern?",
    "All the changes you've done will be lost" : "Alle von Ihnen vorgenommenen Änderungen gehen verloren",
    "Perforated version" : "Perforierte Version",
    "Standard version" : "Standardversion",
    "Custom design" : "Custom color",
    "Standard color" : "Standardfarbe",
    "Custom fit" : "Individuelle Passform",
    "Standard fit" : "Standardpassform",
    "Custom color" : "Freiwählbare Farbe",
    "perforated version" : "Perforierte Version",
    "standard version" : "Standardversion",
    "custom design" : "custom color",
    "standard color" : "Standardfarbe",
    "custom fit" : "Individuelle Passform",
    "standard fit" : "Standardpassform",
    "type the text here" : "Den Text hier eingeben",
    "STROKE" : "STRICH",
    "Yes" : "Ja",
    "SMALL" : "KLEIN",
    "MEDIUM" : "MITTEL",
    "BIG" : "GROSS",
    "Set" : "Einstellen",
    "Request an appointment" : "Einen Termin buchen",
    "Fill-in the form below and request an appointment at one of our Certified Custom Works Centers." : "Füllen Sie das untenstehende Formular aus und buchen Sie einen Termin in einem unserer zertifizierten Custom Works-Center.",
    "You will be able to finalize your purchase with the help of our associates." : "Sie können Ihren Kauf mit der Hilfe unserer Partner abschließen.",
    "Sending the request to Dainese…" : "Anfrage an Dainese senden…",
    "name*" : "Name*",
    "surname*" : "Nachname*",
    "email*" : "E-Mail*",
    "Choose the store…" : "Store auswählen…",
    "Loading…" : "Lädt…",
    "phone*" : "Telefon*",
    "Check our store locator to find the closest Certified Custom Works Center!" : "Finden Sie mit unserem Store Locator das nächstgelegene zertifizierte Custom Works-Center!",
    "Required" : "Erforderlich",
    "* By signing this form, you agree that you have read and understood the Dainese S.p.A. Privacy Policy, available at Privacy Policy Dainese, and agree to permit Dainese S.p.A. to collect and use the personal data accordingly." : <span>* Durch die Unterzeichnung dieses Formulars bestätigen Sie, dass Sie die Datenschutzrichtlinie von Dainese S.p.A., die unter der <a target="_blank" style={{color:'#fff', textDecoration:'underline'}} href="https://policy.dainese.com/privacy"> Datenschutzrichtlinie verfügbarv </a> ist, gelesen und verstanden haben, und dass Sie damit einverstanden sind, dass Dainese S.p.A. dementsprechend Ihre personenbezogenen Daten erhebt und verarbeitet.</span>,
    "I agree to receive special offers, membership benefits, newsletter and brand communications via email and understand I can unsubscribe any time" : "Ich bin damit einverstanden, dass mir besondere Angebote, Mitglieder-Vorteile, Newsletter und Marken-Kommunikation per E-Mail zugesandt werden und es ist mir bekannt, dass ich diese Dienste jederzeit beenden kann.",
    "I consent to provide usage and personal data for a better processing of my interests" : "Ich gebe mein Einverständnis in die Nutzung meiner personenbezogenen Daten zur besseren Betreuung meiner Interessen.",
    "Request" : "Anfrage",
    "Loading 3D viewer…" : "Lädt…",
    "Taking screenshots…" : "Bitte warten Sie noch einen Moment…",
    "Saving customization…" : "Anpassung wird gespeichert…",
    "Updating customization…" : "Anpassung wird aktualisiert…",
    "Save customization" : "Anpassung speichern",
    "Leathers" : "Leder",
    "Click on the leather part you want to customize on the 3D model." : "Am 3D-Modell auf den Lederteil klicken, der angepasst werden soll.",
    "Accessories" : "Zubehör",
    "Click on the accessory you want to customize on the 3D model." : "Am 3D-Modell auf das Accessoire klicken, das angepasst werden soll.",
    "Patches" : "Patches",
    "Select the patch to customize…" : "Das Patch für die Anpassung auswählen…",
    "Select the patch configuration…" : "Die Patch-Konfiguration auswählen…",
    "Update" : "Aktualisieren",
    "New" : "Neu",
    "Do you want to update the customization or create a new one?" : "Möchten Sie die Anpassung aktualisieren oder eine neue erstellen?",
    "Update the customization or create a new one." : "Die Anpassung aktualisieren oder eine neue erstellen.",
    "Configurator" : "Konfigurator",
    "Well done!" : "Sehr gut!",
    "The customization is completed and your product ready to be crafted." : "Die Anpassung ist abgeschlossen und Ihr Produkt ist bereit für die Herstellung.",
    "Please copy and keep the unique code assigned:" : "Bitte kopieren Sie den zugewiesenen exklusiven Code und bewahren Sie ihn auf.",
    "Product Right" : "Rechte Seite",
    "Product front" : "Vorderseite",
    "Product Back" : "Rückseite",
    "Product Left" : "Linke Seite",
    "Proceed" : "Fortfahren",
    "Please provide a configuration code." : "Bitte geben Sie einen Konfigurationscode an.",
    "Configuration not found." : "Konfiguration nicht gefunden.",
    "Looking for customization…" : "Anpassung wird gesucht…",
    "Loading customization…" : "Anpassung wird geladen…",
    "Select your country to begin..." : "Wählen Sie Ihr Land aus, um zu beginnen...",
    "Loading countries..." : "Länder werden geladen...",
    "Start the experience" : "Das Erlebnis starten",
    "Retrieve previous configuration" : "Vorherige Konfiguration abrufen",
    "Enter" : "Senden",
    "Insert the code to retrieve your previous configuration" : "Geben Sie den Code ein, um Ihre vorherige Konfiguration abzurufen",
    "Choose your color" : "Ihre Farbe auswählen",
    "Choose a standard color option or go through our 3D product and customize colors accessories and add-on following your own creativity." : "Wählen Sie eine Standard-Farboption oder fahren Sie über unser 3D-Produkt und personalisieren Sie Farben, Accessoires und Add-ons nach Ihrem Geschmack.",
    "Select your design" : "Wählen Sie Ihre Farbvariante",
    "Select Custom design to change leather colors, select the accessories you want and apply your own text and images" : "Wählen Sie \"Custom Color\", um die Lederfarben zu ändern Wählen Sie die Accessoires, die Sie haben möchten, und verwenden Sie Ihren eigenen Text und Bilder",
    "Please select your design" : "Bitte wählen Sie Ihre Farbvariante",
    "Existing design" : "Bestehende Variante",
    "Customize your garment" : "Ihr Kleidungsstück individuell anpassen",
    "Choose color" : "Farbe auswählen",
    "SELECT" : "AUSWÄHLEN",
    "Choose your fit" : "Ihre Passform auswählen",
    "Choose a standard size or make your garment adjusted to your own body proportions." : "Wählen Sie eine Standardgröße oder passen Sie Ihr Kleidungsstück an Ihre Körperproportionen an.",
    "Would you like to customize your fit?" : "Möchten Sie Ihre Passform individuell anpassen?",
    "No" : "Nein",
    "Choose your size" : "Wählen Sie Ihre Größe",
    "Shop on line" : "Online kaufen",
    "Pick a perforated leather for maximum ventilation or standard for mild ventilation" : "Wählen Sie ein perforiertes Leder für maximale Belüftung oder ein Standardleder für leichte Belüftung",
    "Select leather perforation" : "Lederperforation auswählen",
    "NEXT" : "WEITER",
    "Pick your model" : "Ihr Modell auswählen",
    "These are the models available, choose the one you prefer." : "Diese Modelle sind verfügbar, wählen Sie Ihren Favoriten aus.",
    "Loading products…" : "Produkte werden geladen…",
    "No products available." : "Keine Produkte verfügbar.",
    "Select your product" : "Ihr Produkt auswählen",
    "Please select the product to be customized" : "Bitte wählen Sie das Produkt für die Anpassung aus",
    "SUIT" : "ANZUG",
    "JACKET" : "JACKE",
    "TROUSERS" : "HOSE",
      "BOOTS" : "STIEFEL",
    "Select" : "Auswählen",
    "Standard leather" : "Standardleder",
    "Perforated leather" : "Perforiertes Leder",
    "The 3D model shown is intended for illustration purpose only." : "Das gezeigte 3D-Modell dient nur der Veranschaulichung.",
    "Actual product may vary from the graphical representation." : "Das tatsächliche Produkt kann von der grafischen Darstellung abweichen.",
    "Start" : "Starten",
    "Product" : "Produkt",
    "Design" : "Design",
    "Fit" : "Passform",
    "KNEE_SLIDER" : "Knieslider",
    "ELBOW_SLIDER" : "Ellbogenslider",
    "SHOULDER_PLATE" : "Schulterplatte",
    "KNEE_PLATE" : "Knieplatte",
    "ELBOW_PLATE" : "Ellbogenplatte",
    "knee_sliders" : "Knieslider",
    "elbow_sliders" : "Ellbogenslider",
    "shoulder_plates" : "Schulterplatten",
    "knee_plates" : "Knieplatten",
    "elbow_plates" : "Ellbogenplatten",
    "Knee_sliders": "Knieslider",
    "Elbow_sliders": "Ellbogenslider",
    "Shoulder_plates": "Schulterplatten",
    "Knee_plates": "Knieplatten",
    "Elbow_plates": "Ellbogenplatten",
    "Chest" : "Brustkorb",
    "Upperarm_L" : "Linker Oberarm",
    "Upperarm_R" : "Rechter Oberarm",
    "Back" : "Rücken",
    "Collarbone_L" : "Linkes Schlüsselbein",
    "Collarbone_R" : "Rechtes Schlüsselbein",
    "Forearm_L" : "Linker Unterarm",
    "Forearm_R" : "Rechter Unterarm",
    "Shin_L" : "Rechtes Schienbein",
    "Shin_R" : "Linkes Schienbein",
    "Front_leg_L" : "Linkes Vorderbein",
    "Front_leg_R" : "Rechtes Vorderbein",
    "Back_leg_L" : "Linkes Hinterbein",
    "Back_leg_R" : "Rechtes Hinterbein",
    "Lowerback" : "Lendenbereich",
    "Hump" : "Höcker",
    "Collarbone" : "Schlüsselbein",
    "Forearm" : "Unterarm",
    "Leg" : "Bein",
    "Shin" : "Schienbein",
    "Shoulder" : "Schulter",
    "chest" : "Brustkorb",
    "upperarm_L" : "Linker Oberarm",
    "upperarm_R" : "Rechter Oberarm",
    "back" : "Rücken",
    "collarbone_L" : "Linkes Schlüsselbein",
    "collarbone_R" : "Rechtes Schlüsselbein",
    "forearm_L" : "Linker Unterarm",
    "forearm_R" : "Rechter Unterarm",
    "shin_L" : "Rechtes Schienbein",
    "shin_R" : "Linkes Schienbein",
    "front_leg_L" : "Linkes Vorderbein",
    "front_leg_R" : "Rechtes Vorderbein",
    "back_leg_L" : "Linkes Hinterbein",
    "back_leg_R" : "Rechtes Hinterbein",
    "lowerback" : "Lendenbereich",
    "hump" : "Höcker",
    "collarbone" : "Schlüsselbein",
    "forearm" : "Unterarm",
    "leg" : "Bein",
    "shin" : "Schienbein",
    "shoulder" : "Schulter",
    "Back_1" : "Rücken_1",
    "Back_2" : "Rücken_2",
    "Back_3" : "Rücken_3",
    "Chest_1" : "Brust_1",
    "Chest_3" : "Brust_3",
    "Chest_8" : "Brust_8",
    "Hump_1" : "Höcker_1",
    "Hump_2" : "Höcker_2",
    "Hump_3" : "Höcker_3",
    "Upperarm_L_1" : "Linker Oberarm_1",
    "Upperarm_L_2" : "Linker Oberarm_2",
    "Upperarm_L_3" : "Linker Oberarm_3",
    "Upperarm_R_1" : "Rechter Oberarm_1",
    "Upperarm_R_2" : "Rechter Oberarm_2",
    "Upperarm_R_3" : "Rechter Oberarm_3",
    "Collarbone_L_2" : "Linkes Schlüsselbein_2",
    "Collarbone_R_2" : "Rechtes Schlüsselbein_2",
    "Chest_2" : "Brust_2",
    "Chest_6" : "Brust_6",
    "Thigh_L" : "Oberschenkel_L",
    "Thigh_R" : "Oberschenkel_R",
    "Strap" : "Riemen",
    "Shoulder_L_1" : "Linke Schulter_1",
    "Shoulder_L_2" : "Linke Schulter_2",
    "Shoulder_L_3" : "Linke Schulter_3",
    "Shoulder_R_1" : "Rechte Schulter_1",
    "Shoulder_R_2" : "Rechte Schulter_2",
    "Shoulder_R_3" : "Rechte Schulter_3",
    "Arm_L" : "Linker Arm",
    "Arm_R" : "Rechter Arm",
    "Collarbone_L_1" : "Linkes Schlüsselbein_1",
    "Collarbone_R_1" : "Rechtes Schlüsselbein_1",
    "Thigh_back_L" : "Hinterschenkel links",
    "Thigh_back_R" : "Hinterschenkel rechts",
    "Thigh_front_L" : "Vorderschenkel links",
    "Thigh_front_R" : "Vorderschenkel rechts",
    "Leg_L" : "Linkes Bein",
    "Leg_R" : "Rechtes Bein",
    "Chest_L" : "Linke Brust",
    "Chest_R" : "Rechte Brust",
    "Shoulder_L" : "Linke Schulter",
    "Shoulder_R" : "Rechte Schulter",
    "kangaroo" : "Känguruleder",
    "cowhide" : "Rindsleder",
    "Available in short and tall sizes": "Erhältlich in short and tall Größen",
    "S/T Sizes": "S/T Größen",
    "Choose your size type" : "Wähle deine Größen",
     " - Not available for this model" : " - Für das ausgewählte Modell nicht verfügbar",
    "BackButton" : "zurück",
    "Go to store" : "Online kaufen",
    "Buy online available" : "Kaufen sie online",
    "In-store only" : "Nur in den Geschäften",
    "Click here to know more about patches" : "Klicken Sie hier, um mehr über die Patch zu erfahren",
    "Please note that we will not be able to add the following logos and trade marks: Ducati, Monster, RedBull and VR46. Depending on content and quality of images, our Team will tell you which of the following add-ons will be used:" : "Bitte beachten Sie, dass folgende Logos nicht angebracht werden dürfen: Ducati, Monster, RedBull, sowie VR46. Abhängig von dem Inhalt und der Bildqualität, wird Ihnen unser Team Mitteilen, was realisiert werden kann.",
    "Offers the highest level of perceived quality and the most durability, but it has design limitations.": "Höchste Sicherheitsstandards und Qualität, jedoch gibt es einige Design Limits.",
    "It's an ink printing onto a faux piece of leather that offers complete design freedom, but has a lower perceived quality level, and reduced durability." : "Es handelt sich um Tintendruck auf Kunstleder, der vollständige Gestaltungsfreiheit bietet, jedoch ein geringeres Qualitätsniveau und eine geringere Haltbarkeit aufweist.",
    "Enter your email address to save your garment" : "Geben Sie bitte Ihre E-Mail Adresse ein, um Ihr Kleidungsstück zu speichern.",
    "You will receive a unique Custom Works code in order to retrieve your design anytime" : "Sie werden eine persönliche Custom Works Nummer erhalten, um jederzeit auf Ihren Entwurf zugreifen zu können.",
    "Submit" : "Einreichen",
    "Thank you!": "Vienlen Dank!",
    "Please look for an email, checking in junk folder as well, with your unique Custom Works code.": "Schauen Sie bitte auch in der Spam-Box, ob die E-Mail mit Ihrer Custom Works Nummer angekommen ist.",
    "This allows you to view the design at any time. Please note that any changes will create a new code.": "Das ermöglicht Ihnen jederzeit auf Ihren Design zuzugreifen. Bitte beachten Sie, dass bei jeder Änderung eine neue Nummer erstellt wird.",
    "Your unique Custom Works code code is:": "Ihre persönliche Custom Works Nummer lautet:",
    "Reconfigure": "Erneut konfigurieren",
    "Let's get started on your Dainese Custom Works project!" : "Lassen sie uns mit ihrem Custom Works projekt beginnen!",
    "Fill-in the form below and select if you would like to purchase from one of our Retail Stores, Certified Centers, Design Centers or directly from Dainese (only available for Custom Colour).": "Füllen Sie den Formular unten aus und wählen Sie, ob Sie gerne in einem authorisierten Dainese Store bestellen möchten, bei einem authorisierten Retail Stores, Certified Centers, Design Centers (nur für Standardgrößen verfügbar) oder direkt bei Dainese (Nur Custom Colour möglich) bestellen möckten.",
    "* I have authorization to use trademarks and images" : "* Ich habe die Erlaubnis Markenlogos und Bilder zu verwenden",
    "A member of the Dainese Custom Works will be contacting you" : "Ein Mitglied aus unserem Consumer Care Team wird bald auf Sie zurück kommen",
    "A message will be sent to the store and you will be contacted": "Der Dainese Store wird eine Nachricht erhalten und Sie werden daraufhin kontaktiert werden",
    "Buy in-store" : "Kaufen Sie in Store",
    "Buy Online" : "Kaufen Sie Online",
    "for submitting your design" : "um Ihren Entwurf einzuschicken",
    "A member of our Custom Works Consumer Care team will contact you shortly to confirm your design and talk you through the ordering process." : "Ein Mitglied aus unserem Consumer Care Team wird bald auf Sie zurückkommen bzgl. Ihrem Entwurf und dem weiteren Verfahren.",
    "We have submitted your design to your preferred store." : "Wir haben Ihren Entwurf an den Dainese Store Ihrer Wahl weitergeleitet.",
    "They will contact you in order to arrange an appointment." : "Einer der Mitarbeiter wird sich bald mit Ihnen in Verbindung setzen, um einen Termin mit Ihnen zu vereinbaren.",
    "Please use the below reference code:" : "Vewenden Sie bitte folgende Referenznummer:",
    "Please allow 72 hours for the store to contact you, if you have not heard anything after that please contact us directly HERE so we can assist you." :<span>Sollten Sie vom Dainese Store binnen 72 Stunden nicht kontaktiert werden, setzen Sie sich  bitte direkt <a className="thankyou__mailto" target="_blank" href="https://www.dainese.com/de/de/dainese/contact-us/contact-dainese.html">HIER</a> mit uns in Verbindung, um einen angemessenen Service zu erhalten.</span>,
    "Cannot find a store near you? CLICK HERE" : "Sie können kein Geschäft in Ihrer Nähe finden? KLICKEN SIE HIER",
    "Special colors" : "SONDERFARBEN",
    "Standard colors" : "STANDARDFARBEN",
    "Fluorescent colors" : "FLUORESZIERENDE FARBEN",
    "There was an error saving your garment. You are being redirected back, check your changes and save again. If repeated please contact the help desk." : "Beim Speichern Ihres Kleidungsstücks ist ein Fehler aufgetreten. Sie werden zurückgeleitet, überprüfen Sie Ihre Änderungen und speichern Sie erneut. Bei Wiederholung wenden Sie sich bitte an den Helpdesk."
  },
  es:{
    "M" : "Hombre",
    "F" : "Mujer",
    "COMMERCIAL_TRANSFER" : "TRANSFER",
    "COMMERCIAL_LEATHER_PATCH" : "PARCHE DE PIEL",
    "COMMERCIAL_DIRECT_PRINT" : "IMPRESIÓN DIRECTA",
    "COMMERCIAL_STANDARD" : "ESTÁNDAR",
    "COMMERCIAL_COLORED" : "CUSTOM",
    "COMMERCIAL_LIMITED" : "LIMITED",
    "Next" : "Siguiente",
    "..." : "...",
    "Your unique customization code:" : "Su código único de personalización:",
    "Disclaimer" : "Exención de responsabilidad",
    "Privacy policy" : "Política de privacidad",
    "English" : "inglés",
    "Italian" : "Italiano",
    "Image" : "Imagen",
    "Text" : "TEXTO",
    "Browse…" : "Examinar…",
    "Only PNG and JPG file under 2MB allowed." : "Solo están permitidos los archivos PNG y JPG de tamaño inferior a 2 MB.",
    "Need suggestions?" : "¿Necesita ayuda?",
    "Are you sure you want to change preset?" : "¿Está seguro de querer cambiar los ajustes predeterminados?",
    "All the changes you've done will be lost" : "Se perderán todos los cambios que haya realizado",
    "Perforated version" : "Versión perforada",
    "Standard version" : "Versión estándar",
    "Custom design" : "Coloración personalizada",
    "Standard color" : "Color estándar",
    "Custom color" : "Color personalizado",
    "Custom fit" : "Ajuste personalizado",
    "Standard fit" : "Ajuste estándar",
    "perforated version" : "Versión perforada",
    "standard version" : "Versión estándar",
    "custom design" : "coloración personalizada",
    "standard color" : "Color estándar",
    "custom fit" : "Ajuste personalizado",
    "standard fit" : "Ajuste estándar",
    "type the text here" : "escriba aquí el texto",
    "STROKE" : "STROKE",
    "Yes" : "Sí",
    "SMALL" : "PEQUEÑO",
    "MEDIUM" : "MEDIANO",
    "BIG" : "GRANDE",
    "Set" : "Configurar",
    "Request an appointment" : "Solicitar una cita",
    "Fill-in the form below and request an appointment at one of our Certified Custom Works Centers." : "Rellene el siguiente formulario para solicitar una cita en uno de nuestros Centros Custom Works certificados.",
    "You will be able to finalize your purchase with the help of our associates." : "Podrá finalizar su compra con la ayuda de nuestros asociados.",
    "Sending the request to Dainese…" : "Enviando la solicitud a Dainese…",
    "name*" : "nombre*",
    "surname*" : "apellidos*",
    "email*" : "e-mail*",
    "Choose the store…" : "Seleccione la tienda…",
    "Loading…" : "Cargando…",
    "phone*" : "teléfono*",
    "Check our store locator to find the closest Certified Custom Works Center!" : "Para encontrar el Centro Custom Works certificado más cercano utilice nuestro localizador de tiendas.",
    "Required" : "Obligatorio",
    "* By signing this form, you agree that you have read and understood the Dainese S.p.A. Privacy Policy, available at Privacy Policy Dainese, and agree to permit Dainese S.p.A. to collect and use the personal data accordingly." : <span>* Al firmar este formulario, confirma que ha leído y entendido la Política de Privacidad de Dainese S.p.A. disponible en <a target="_blank" style={{color:'#fff', textDecoration:'underline'}} href="https://policy.dainese.com/privacy">Política de privacidad de Dainese</a>, y que autoriza a que Dainese S.p.A. recoja y utilice sus datos personales para los fines descritos.</span>,
    "I agree to receive special offers, membership benefits, newsletter and brand communications via email and understand I can unsubscribe any time" : "Estoy de acuerdo en recibir ofertas especiales, ventajas exclusivas para socios, boletines informativos y comunicaciones de la marca por correo electrónico, y soy consciente de que puedo cancelar la suscripción en cualquier momento",
    "I consent to provide usage and personal data for a better processing of my interests" : "Consiento que se utilicen mis datos personales y de navegación para un mejor procesamiento adaptado a mis intereses reales",
    "Request" : "Solicitud",
    "Loading 3D viewer…" : "Cargando…",
    "Taking screenshots…" : "Espere aún un momento…",
    "Saving customization…" : "Guardando personalización…",
    "Updating customization…" : "Actualizando personalización…",
    "Save customization" : "Guardar personalización",
    "Leathers" : "Pieles",
    "Click on the leather part you want to customize on the 3D model." : "Haga clic en el modelo tridimensional sobre la pieza de piel que desea personalizar.",
    "Accessories" : "ACCESORIOS",
    "Click on the accessory you want to customize on the 3D model." : "Haga clic en el modelo tridimensional sobre el accesorio que desea personalizar.",
    "Patches" : "Parches",
    "Select the patch to customize…" : "Seleccione el parche a personalizar…",
    "Select the patch configuration…" : "Seleccione la configuración del parche…",
    "Update" : "Actualizar",
    "New" : "Nuevo",
    "Do you want to update the customization or create a new one?" : "¿Desea actualizar la personalización o crear una nueva?",
    "Update the customization or create a new one." : "Actualizar la personalización o crear una nueva.",
    "Configurator" : "Configurador",
    "Well done!" : "¡Estupendo!",
    "The customization is completed and your product ready to be crafted." : "Se ha completado la personalización y el producto ha quedado listo para su fabricación.",
    "Please copy and keep the unique code assigned:" : "Por favor, copie y guarde el código único asignado,",
    "Product Right" : "Derecha del producto",
    "Product front" : "Parte frontal de producto",
    "Product Back" : "Parte posterior de producto",
    "Product Left" : "Izquierda de producto",
    "Proceed" : "Continuar",
    "Please provide a configuration code." : "Introduzca un código de configuración.",
    "Configuration not found." : "Configuración no encontrada.",
    "Looking for customization…" : "Buscando personalización…",
    "Loading customization…" : "Cargando personalización…",
    "Select your country to begin..." : "Seleccione en primer lugar su país de origen...",
    "Loading countries..." : "Cargando países...",
    "Start the experience" : "Inicia la experiencia",
    "Retrieve previous configuration" : "Recuperar la configuración anterior",
    "Enter" : "Introducir",
    "Insert the code to retrieve your previous configuration" : "Inserte el código para obtener la configuración previa",
    "Choose your color" : "Seleccione su color",
    "Choose a standard color option or go through our 3D product and customize colors accessories and add-on following your own creativity." : "Seleccione una opción estándar de color o navegue por nuestro modelo tridimensional y personalice los colores, los accesorios y los complementos a su gusto.",
    "Select your design" : "Seleccione tu coloración favorida",
    "Select Custom design to change leather colors, select the accessories you want and apply your own text and images" : "Seleccione \"Color personalizado\" para cambiar los colores de la piel, seleccione los accesorios que desea y aplique su texto e imágenes propios",
    "Please select your design" : "Por favor, seleccione tu coloración favorida",
    "Existing design" : "Coloraciones disponibles",
    "Customize your garment" : "Personalice su traje",
    "Choose color" : "Seleccione el color",
    "SELECT" : "SELECCIONAR",
    "Choose your fit" : "Seleccione su corte",
    "Choose a standard size or make your garment adjusted to your own body proportions." : "Seleccione una talla estándar o ajuste su traje a las proporciones de su propio cuerpo.",
    "Would you like to customize your fit?" : "¿Desea personalizar su corte?",
    "No" : "No",
    "Choose your size" : "Seleccione su talla",
    "Shop on line" : "Comprar en línea",
    "Pick a perforated leather for maximum ventilation or standard for mild ventilation" : "Seleccione una piel perforada si desea la máxima ventilación o una piel estándar para una ventilación media",
    "Select leather perforation" : "Seleccione la perforación de la piel",
    "NEXT" : "SIGUIENTE",
    "Pick your model" : "Elija su modelo",
    "These are the models available, choose the one you prefer." : "Estos son los modelos disponibles, seleccione el que prefiera.",
    "Loading products…" : "Cargando productos…",
    "No products available." : "No hay productos disponibles.",
    "Select your product" : "Seleccione su producto",
    "Please select the product to be customized" : "Seleccione el producto a personalizar",
    "SUIT" : "TRAJE",
    "JACKET" : "CHAQUETA",
    "TROUSERS" : "PANTALONES",
    "BOOTS" : "BOTAS",
    "Select" : "Seleccionar",
    "Standard leather" : "Piel estándar",
    "Perforated leather" : "Piel perforada",
    "The 3D model shown is intended for illustration purpose only." : "El modelo tridimensional que se muestra es solo para fines ilustrativos.",
    "Actual product may vary from the graphical representation." : "El producto real podría presentar diferencias respecto a la representación gráfica.",
    "Start" : "Iniciar",
    "Product" : "Producto",
    "Design" : "Diseño",
    "Fit" : "El ajuste",
    "KNEE_SLIDER" : "Deslizador rodilla",
    "ELBOW_SLIDER" : "Deslizador codo",
    "SHOULDER_PLATE" : "Placa hombro",
    "KNEE_PLATE" : "Placa rodilla",
    "ELBOW_PLATE" : "Placa codo",
    "knee_sliders" : "Deslizadores rodilla",
    "elbow_sliders" : "Deslizadores codo",
    "shoulder_plates" : "Placas hombro",
    "knee_plates" : "Placas rodilla",
    "elbow_plates" : "Placas codo",
    "Knee_sliders": "Deslizadores rodilla",
    "Elbow_sliders": "Deslizadores codo",
    "Shoulder_plates": "Placas hombro",
    "Knee_plates": "Placas rodilla",
    "Elbow_plates": "Placas codo",
    "chest" : "El tórax",
    "upperarm_L" : "Brazo superior izquierdo",
    "upperarm_R" : "Brazo superior derecho",
    "back" : "Espalda",
    "collarbone_L" : "Clavícula izquierda",
    "collarbone_R" : "Clavícula derecha",
    "forearm_L" : "Antebrazo izquierdo",
    "forearm_R" : "Antebrazo derecho",
    "shin_L" : "Espinilla derecha",
    "shin_R" : "Espinilla izquierda",
    "front_leg_L" : "Parte delantera pierna izquierda",
    "front_leg_R" : "Parte delantera pierna derecha",
    "back_leg_L" : "Parte trasera pierna izquierda",
    "back_leg_R" : "Parte trasera pierna derecha",
    "lowerback" : "Parte inferior de la espalda",
    "hump" : "Joroba",
    "collarbone" : "Clavículas",
    "forearm" : "Antebrazo",
    "leg" : "Pierna",
    "shin" : "Espinilla",
    "shoulder" : "Hombrera",
    "Chest" : "El tórax",
    "Upperarm_L" : "Brazo superior izquierdo",
    "Upperarm_R" : "Brazo superior derecho",
    "Back" : "Espalda",
    "Collarbone_L" : "Clavícula izquierda",
    "Collarbone_R" : "Clavícula derecha",
    "Forearm_L" : "Antebrazo izquierdo",
    "Forearm_R" : "Antebrazo derecho",
    "Shin_L" : "Espinilla derecha",
    "Shin_R" : "Espinilla izquierda",
    "Front_leg_L" : "Parte delantera pierna izquierda",
    "Front_leg_R" : "Parte delantera pierna derecha",
    "Back_leg_L" : "Parte trasera pierna izquierda",
    "Back_leg_R" : "Parte trasera pierna derecha",
    "Lowerback" : "Parte inferior de la espalda",
    "Hump" : "Joroba",
    "Collarbone" : "Clavículas",
    "Forearm" : "Antebrazo",
    "Leg" : "Pierna",
    "Shin" : "Espinilla",
    "Shoulder" : "Hombrera",
    "Back_1" : "Espalda_1",
    "Back_2" : "Espalda_2",
    "Back_3" : "Espalda_3",
    "Chest_1" : "Pecho_1",
    "Chest_3" : "Pecho_3",
    "Chest_8" : "Pecho_8",
    "Hump_1" : "Joroba_1",
    "Hump_2" : "Joroba_2",
    "Hump_3" : "Joroba_3",
    "Upperarm_L_1" : "Brazo superior izquierdo_1",
    "Upperarm_L_2" : "Brazo superior izquierdo_2",
    "Upperarm_L_3" : "Brazo superior izquierdo_3",
    "Upperarm_R_1" : "Brazo superior derecho_1",
    "Upperarm_R_2" : "Brazo superior derecho_2",
    "Upperarm_R_3" : "Brazo superior derecho_3",
    "Collarbone_L_2" : "Clavícula izquierda_2",
    "Collarbone_R_2" : "Clavícula derecha_2",
    "Chest_2" : "Pecho_2",
    "Chest_6" : "Pecho_6",
    "Thigh_L" : "Muslo_I",
    "Thigh_R" : "Muslo_D",
    "Strap" : "Correa",
    "Shoulder_L_1" : "Hombro izquierdo_1",
    "Shoulder_L_2" : "Hombro izquierdo_2",
    "Shoulder_L_3" : "Hombro izquierdo_3",
    "Shoulder_R_1" : "Hombro derecho_1",
    "Shoulder_R_2" : "Hombro derecho_2",
    "Shoulder_R_3" : "Hombro derecho_3",
    "Arm_L" : "Brazo izquierdo",
    "Arm_R" : "Brazo derecho",
    "Collarbone_L_1" : "Clavícula izquierda_1",
    "Collarbone_R_1" : "Clavícula derecha_1",
    "Thigh_back_L" : "Parte trasera muslo izquierdo",
    "Thigh_back_R" : "Parte trasera muslo derecho",
    "Thigh_front_L" : "Parte delantera muslo izquierdo",
    "Thigh_front_R" : "Parte delantera muslo derecho",
    "Leg_L" : "Pierna izquierda",
    "Leg_R" : "Pierna derecha",
    "Chest_L" : "Pecho izquierdo",
    "Chest_R" : "Pecho derecho",
    "Shoulder_L" : "Hombro izquierdo",
    "Shoulder_R" : "Hombro derecho",
    "kangaroo" : "canguro",
    "cowhide" : "piel de vaca",
    "Available in short and tall sizes": "Disponible en tallas short and tall",
    "S/T Sizes": "S/T tallas",
    "Choose your size type" : "Elija su tipo de talla",
     " - Not available for this model" : " - No disponible para el modelo seleccionado",
    "BackButton" : "espalda",
    "Go to store" : "comprar en linea",
    "Buy online available" : "Comprar online",
    "In-store only" : "Sólo en las tiendas",
    "Click here to know more about patches" : "Clique aquí, para saber más sobre los parches",
    "Please note that we will not be able to add the following logos and trade marks: Ducati, Monster, RedBull and VR46. Depending on content and quality of images, our Team will tell you which of the following add-ons will be used:" : "Por favor, tenga en cuenta que no podemos añadir los logos siguientes: DUCATI, MONSTER, REDBULL y VR46. Según la calidad de las imagenes, nuestro Equipo va confirmar cual de los siguientes add-ons van ser utilizados:",
    "Offers the highest level of perceived quality and the most durability, but it has design limitations.": "Ofrece el nivel más alto de calidad percibida y la mayor durabilidad, pero tiene limitaciones de diseño.",
    "It's an ink printing onto a faux piece of leather that offers complete design freedom, but has a lower perceived quality level, and reduced durability." : "Es una impresión de tinta sobre un parche de piel sintético que ofrece total libertad de diseño, pero tiene un menor nivel de calidad percibido y una durabilidad reducida.",
    "Enter your email address to save your garment" : "Ingrese su dirección de correo electrónico para guardar su prenda personalizada",
    "You will receive a unique Custom Works code in order to retrieve your design anytime" : "Recibirá un código único asignado para recuperar en cualquier momento su diseño Customs Works.",
    "Submit" : "Enviar",
    "Thank you!": "¡Gracias!",
    "Please look for an email, checking in junk folder as well, with your unique Custom Works code.": "Busque un correo electrónico, revisando también la carpeta de correos no deseados, con su código único de Custom Works.",
    "This allows you to view the design at any time. Please note that any changes will create a new code.": "Esto le permite ver el diseño en cualquier momento. Tenga en cuenta que cualquier cambio creará un nuevo código.",
    "Your unique Custom Works code code is:": "Su código único de código de Custom Works es:",
    "Reconfigure": "Reconfigurar",
    "Let's get started on your Dainese Custom Works project!" : "¡Ahora vamos con su proyecto de Custom Works!",
    "Fill-in the form below and select if you would like to purchase from one of our Retail Stores, Certified Centers, Design Centers or directly from Dainese (only available for Custom Colour).": "Complete el siguiente formulario y seleccione si desea comprar en una de nuestras Retail Store, Certified Center, Design Center (solo disponible para tamaños estándar) o directamente de Dainese (solo disponible para Custom Color).",
    "* I have authorization to use trademarks and images" : "* Tengo autorización para usar marcas registradas e imágenes",
    "A member of the Dainese Custom Works will be contacting you" : "Un miembro de Dainese Custom Works se comunicará con usted",
    "A message will be sent to the store and you will be contacted": "Se enviará un mensaje a la tienda y usted será contactado",
    "Buy in-store" : "Comprar en la tienda",
    "Buy Online" : "Comprar Online",
    "for submitting your design" : "para enviar su diseño",
    "A member of our Custom Works Consumer Care team will contact you shortly to confirm your design and talk you through the ordering process." : "Un referente de nuestro equipo de Consumer Care para el Custom Works se comunicará con usted muy pronto para confirmar su diseño y explicar el procedimiento del pedido.",
    "We have submitted your design to your preferred store." : "Hemos enviado su diseño a su tienda preferida.",
    "They will contact you in order to arrange an appointment." : "Se pondrán en contacto para reservar una sesión.",
    "Please use the below reference code:" : "Utilice el siguiente código de referencia:",
    "Please allow 72 hours for the store to contact you, if you have not heard anything after that please contact us directly HERE so we can assist you." :<span>Espere 72 horas para que la tienda se ponga en contacto con usted, si nadie contestó dentro de dichas 72 horas, por favor contáctenos directamente <a className="thankyou__mailto" target="_blank" href="https://www.dainese.com/es/es/dainese/contact-us/contact-dainese.html">AQUÌ</a> para suporte.</span>,
    "Cannot find a store near you? CLICK HERE" : "¿No puede encontrar una tienda cerca de usted? HAGA CLIC AQUÍ",
    "Special colors" : "COLORES ESPECIALES",
    "Standard colors" : "COLORES STANDARD",
    "Fluorescent colors" : "COLORES FLUORESCENTES",
    "There was an error saving your garment. You are being redirected back, check your changes and save again. If repeated please contact the help desk." : "Se produjo un error al guardar tu prenda. Se le redirigirá de nuevo, compruebe los cambios y vuelva a guardar. Si se repite, comuníquese con el servicio de asistencia técnica."
  }

};

export let
  __ = Translator.translate;



// WEBPACK FOOTER //
// ./src/Translator.js